import React from "react";

const Loading = () => {
  return (
    <div className='vh-100 d-flex flex-column align-items-center justify-content-center'>
      {/* Spinner Row */}
      <div className='d-flex gap-3 mb-3'>
        <div className='spinner-grow text-danger' role='status' />
        <div className='spinner-grow text-warning' role='status' />
        <div className='spinner-grow text-success' role='status' />

        <div className='spinner-grow text-primary' role='status' />
        <div className='spinner-grow text-info' role='status' />

        <div className='spinner-grow text-secondary' role='status' />
        <div className='spinner-grow text-dark' role='status' />
      </div>

      {/* Text */}
      <p className='mb-0'>Loading checkout form...</p>
    </div>
  );
};

export default Loading;
